import { render, staticRenderFns } from "./buySelect.vue?vue&type=template&id=4c6aa41a&scoped=true&"
import script from "./buySelect.vue?vue&type=script&lang=js&"
export * from "./buySelect.vue?vue&type=script&lang=js&"
import style0 from "./buySelect.vue?vue&type=style&index=0&id=4c6aa41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6aa41a",
  null
  
)

export default component.exports